<script setup>
/* eslint-disable */
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useFavouritesStore } from '@/stores/favourites';
import { useMarketsStore } from '@/stores/markets';
import { useFixtureStore } from '@/stores/fixture';
import { useLiveSportsStore } from '@/stores/live_sports';
import FeaturedFixtureOverviewOdd from '@/components/pre_sports/FeaturedFixtureOverviewOdd.vue';
import JerseyIcon from '@/assets/svgs/jerseyIcon.vue';
import { useBestlineVideoStore } from '@/stores/bestline_video';
const bestlineVideoStore = useBestlineVideoStore();

const router = useRouter();
const favouritesStore = useFavouritesStore();
const marketsStore = useMarketsStore();
const liveSportsStore = useLiveSportsStore();
const fixtureStore = useFixtureStore();

import commonSvgs from '@/assets/svgs/commonSvgs.json'
const svg_data = ref(commonSvgs);

const props = defineProps({
	primary_overview_market: {
		required: true,
	},
	fixture: {
		type: Object,
		required: true,
	}
});

const showVideoOrVirtualLive = computed(() => {
	let has_video = false;

	has_video = bestlineVideoStore.hasVideo(props.fixture);

	let has_vl = false

	if (has_video && has_vl) return 'video';
	else if (has_video) return 'video';
	else if (has_vl) return 'vl';

	return null;
});

const toggleFavourite = () => {
	favouritesStore.toggleFixture(props.fixture.id);
}

const goToFixture = () => {
	if (router.currentRoute.value.name == 'live-Esports-eventview') {
		router.push({ name: 'live-Esports-eventview', params: { fixture_id: props.fixture.id } })
		return;
	}

	router.push({ name: 'live-sports-eventview', params: { fixture_id: props.fixture.id } })
}

const primaryOverviewMarketOdds = computed(() => {
	if (!props.fixture.overview_markets.hasOwnProperty(props.primary_overview_market.slug)) return [];

	return props.fixture.overview_markets[props.primary_overview_market.slug];
});

</script>
<template>
	<div class="live-info-outer">
		<div class="live-top-info">
			<div class="star-ico" @click="toggleFavourite">
				<svg xmlns="http://www.w3.org/2000/svg" width="12" height="11.143" viewBox="0 0 12 11.143">
					<path :style="{fill: fixture.favourite  ? 'var(--primary)' : ''}" id="Icon_ionic-ios-star" :class="`fixture-${fixture.id}`" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" fill="var(--tab-gray)"></path>
				</svg>
			</div>
			<div class="live-badge" v-html="svg_data.live_badge"></div>
			<div class="live-data-desktop" v-if="liveSportsStore.hasFixtureClock(fixture.sport_id)">
				<h3>
					<dl>
						{{ fixtureStore.fixtureClockTime(fixture) }}
						<dt> {{ fixtureStore.fixtureState(fixture) }} </dt>
					</dl>

					<span></span>
				</h3>
			</div>
			<div class="live-data-desktop" v-else>
				<h3> {{ fixtureStore.fixtureState(fixture) }} </h3>
				<span></span>
			</div>
			<div v-if="showVideoOrVirtualLive == 'video'" class="field-icon-container"  @click="goToFixture">
				<svg xmlns="http://www.w3.org/2000/svg" class="video-icon" width="50px" height="34px"
					viewBox="0 0 50 34" fill="none"
					style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd">
					<rect x="1" y="1" width="48" height="32" rx="4" ry="4" class="border" />
					<polygon points="19,8.5 34,17 19,25.5" class="play-fill" />
				</svg>
			</div>
		</div>
		<div class="live-info-inner">

			<div class="playing-team" @click="goToFixture">
				<div class="playing-team-inner team-one">
					<div class="team-live" :class="fixture.statistics?.possession &&fixture.statistics?.possession==1?'active':''">
						<div class="playing-team-jersey">
							<img v-if="fixtureStore.getParticipantLogo(fixture.participant_logos)" :src="fixtureStore.getParticipantLogo(fixture.participant_logos).home" alt="#">
							<JerseyIcon v-if="!fixtureStore.getParticipantLogo(fixture.participant_logos) && fixtureStore.getParticipantJersey(fixture.jersey_colors)" :jerseyColor="fixtureStore.getParticipantJersey(fixture.jersey_colors).home" />
							<h6>{{ fixture.participants[0] }}</h6>
						</div>
					</div>
					<div class="team-live-score">
						<span :style="{'max-width': props.fixture.sport_id == 22 ? '42px' : '', 'min-width': props.fixture.sport_id == 22 ? '42px' : ''}" class="current">{{ fixture.statistics?.p1_score }}</span>
						<span :style="{'max-width': props.fixture.sport_id == 22 ? '42px' : '', 'min-width': props.fixture.sport_id == 22 ? '42px' : ''}" v-if="liveSportsStore.hasThreeScores(fixture.sport_id)">{{ fixture.statistics?.p1_games }}</span>
						<span :style="{'max-width': props.fixture.sport_id == 22 ? '42px' : '', 'min-width': props.fixture.sport_id == 22 ? '42px' : ''}" v-if="liveSportsStore.hasTwoScores(fixture.sport_id)">{{ fixture.statistics?.p1_points }}</span>
					</div>

				</div>
				<div class="playing-team-inner team-one" v-if="!liveSportsStore.hasOneParticipant(fixture.sport_id) && !fixture.outright">
					<div class="team-live" :class="fixture.statistics?.possession &&fixture.statistics?.possession==2?'active':''">
						<div class="playing-team-jersey">
							<img v-if="fixtureStore.getParticipantLogo(fixture.participant_logos)" :src="fixtureStore.getParticipantLogo(fixture.participant_logos).away" alt="#">
							<JerseyIcon v-if="!fixtureStore.getParticipantLogo(fixture.participant_logos) && fixtureStore.getParticipantJersey(fixture.jersey_colors)" :jerseyColor="fixtureStore.getParticipantJersey(fixture.jersey_colors).away" />
							<h6>{{ fixture.participants[1] }}</h6>
						</div>
					</div>
					<div class="team-live-score">
						<span :style="{'max-width': props.fixture.sport_id == 22 ? '42px' : '', 'min-width': props.fixture.sport_id == 22 ? '42px' : ''}" class="current">{{ fixture.statistics?.p2_score }}</span>
						<span :style="{'max-width': props.fixture.sport_id == 22 ? '42px' : '', 'min-width': props.fixture.sport_id == 22 ? '42px' : ''}" v-if="liveSportsStore.hasThreeScores(fixture.sport_id)">{{ fixture.statistics?.p2_games }}</span>
						<span :style="{'max-width': props.fixture.sport_id == 22 ? '42px' : '', 'min-width': props.fixture.sport_id == 22 ? '42px' : ''}" v-if="liveSportsStore.hasTwoScores(fixture.sport_id)">{{ fixture.statistics?.p2_points }}</span>
					</div>
				</div>
			</div>

		</div>
		<div class="betting_info" v-if="primary_overview_market != null">
			<FeaturedFixtureOverviewOdd
				:overview_market_header_name="primary_overview_market.odd_names[0]"
				:overview_odd="primaryOverviewMarketOdds[0]"
				:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
				:fixture_id="props.fixture.id"
			/>

			<FeaturedFixtureOverviewOdd v-if="primary_overview_market.three_way"
				:overview_market_header_name="primary_overview_market.odd_names[1]"
				:overview_odd="primaryOverviewMarketOdds[1]"
				:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
				:fixture_id="props.fixture.id"
			/>

			<FeaturedFixtureOverviewOdd
				:overview_market_header_name="primary_overview_market.odd_names[2]"
				:overview_odd="primary_overview_market.three_way ? primaryOverviewMarketOdds[2] : primaryOverviewMarketOdds[1]"
				:needs_indicator="marketsStore.overviewMarketNeedsIndicator(primary_overview_market)"
				:fixture_id="props.fixture.id"
			/>
		</div>

	</div>
</template>
<style scoped>
.sports-main .eventview-pannel .sports-outer-left .sports-left-sidebar .accordion-outer .accordion .accordion-item .accordion-content .sidebar-bet-info .live-info-outer .live-info-inner .playing-team .playing-team-inner h6
{
	white-space: unset !important;
}

.sports-main .eventview-pannel .sports-outer-left .sports-left-sidebar .accordion-outer .accordion .accordion-item .accordion-content .sidebar-bet-info.round-game-outer .live-info-outer .live-top-info {
    display: grid;
    grid-template-columns: auto auto auto 1fr;
    align-items: center;
    gap: 6px;
}

.field-icon-container {
	text-align: right;
}

.video-icon{
    width: 25px;
    height: 17px;
}

.video-icon {
	width: 25px;
	height: 17px;
}


.play-fill {
	fill: var(--border-light);
}

.border {
	fill: none;
	stroke: var(--border-light);
	stroke-width: 1;
}

</style>